import CanvasSVGDrawer from './CanvasSVGDrawer';
class DrawerCollection {
    constructor() {
        this._drawers = {};
    }

    retrieveDrawer(drawerId) {
        
        if (this._drawers[drawerId]) {
            return this._drawers[drawerId];
        }

        console.warn(`Drawer ${drawerId} not Found`);
        return null;
    }

    initDrawers(drawerConfigs) {
        let promise = new Promise((resolve, reject) => {
            let loadCount = 0;
            window.drawers = [];
            let svgPathSortedConfigs = {};
            for (var i = 0; i < drawerConfigs.length; i++) {
                let { path } = drawerConfigs[i];
                if (!svgPathSortedConfigs[path]) {
                    svgPathSortedConfigs[path] = [];
                }
                svgPathSortedConfigs[path].push(drawerConfigs[i]);
            }

            for (let path in svgPathSortedConfigs) {
                let Connect = new XMLHttpRequest();
                Connect.onload = (e) => {
                    let drawerConfigs = svgPathSortedConfigs[path];
                    for (let drawerConfig of drawerConfigs) {
                        let { altClass,style, index } = drawerConfig;
                        let drawerClass = altClass||CanvasSVGDrawer
                        let drawer = new drawerClass(style);
                        
                        drawer.svgTemplateString = e.target.response;
                        //get color from svg
                        let svg = e.target.response;
                       
                        drawer.legendColor = svg.match(/fill:(#[a-zA-Z0-9]{6})/)[1];

                        drawer.createImage(() => {
                            loadCount++;
                            this._drawers[index] = drawer;
                           
                            if (loadCount === drawerConfigs.length) {
                                resolve();
                            }
                        });
                    }
                };
                Connect.open("GET", path, true);
                Connect.setRequestHeader("Content-Type", "text/xml");
                Connect.send(null);
            }
        });

        return promise;
    }
}

export default DrawerCollection;